<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5>Cadastros / Vendas de Crédito / Planos Recorrentes / Intermediações</h5>
                </div>
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="datainicial">
                                    Data Inicial:
                                </label>
                                <input class="form-control" type="date" id="datainicial" v-model="startDate"/>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="form-group">
                                <label for="datainicial">
                                    Data Final:
                                </label>
                                <input class="form-control" type="date" id="datafinal" v-model="endDate"/>
                            </div>
                        </div>
                    </div>
                    <div class="row"> 
                        <div class="col-lg-12">
                            <button type="button" class="btn btn-primary" @click="filterChart">Filtrar</button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-9">
                            <canvas ref="canvas" style="height: 500px"></canvas>
                        </div>
                        <div class="col-lg-3">
                            <h2>Resumo do Periodo</h2>
                            <ul class="stat-list">
                                <li>
                                    <h2 class="no-margins ">{{ registerTotal }}</h2>
                                    <small>Total de cadastros neste período</small>
                                </li>
                                <li><hr></li>
                                <li>
                                    <h2 class="no-margins">
                                        R$  {{ parseFloat(creditsTotalIncome).toFixed(2).replace('.', ',') }}
                                    </h2>
                                    <small>Total em Créditos (sem taxa)</small>
                                </li>
                                <li>
                                    <h2 class="no-margins">
                                        {{ creditsTotal }}
                                    </h2>
                                    <small>Total de vendas de Créditos</small>
                                </li>
                                <li><hr></li>
                                <li>
                                    <h2 class="no-margins">
                                        R$  {{ parseFloat(recurrentTotalIncome).toFixed(2).replace('.', ',') }}
                                    </h2>
                                    <small>Total em Recorrentes (sem taxa)</small>
                                </li>
                                <li>
                                    <h2 class="no-margins">
                                        {{ recurrentTotal }}
                                    </h2>
                                    <small>Total de vendas de Recorrentes</small>
                                </li>
                                <li><hr></li>
                                <li>
                                    <h2 class="no-margins">
                                        R$  {{ parseFloat(bidSplitTotalIncome).toFixed(2).replace('.', ',') }}
                                    </h2>
                                    <small>Total em intermediações (taxa)</small>
                                </li>
                                <li>
                                    <h2 class="no-margins">
                                        {{ bidSplitTotal }}
                                    </h2>
                                    <small>Total de intermediações</small>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Bar } from 'vue-chartjs';
    import moment from 'moment';

    export default {
        extends: Bar,
        data() {
            return {
                creditsTotal: 0,
                recurrentTotal: 0,
                registerTotal: 0,
                bidSplitTotal: 0,
                creditsTotalIncome: 0,
                recurrentTotalIncome: 0,
                bidSplitTotalIncome: 0,
                startDate: '',
                endDate: '',
            };
        },
        async mounted() {
            await this.updateChart();
        },
        methods: {
            async updateChart() {

                try {

                    const { data: registers } = await axios.get('/admin/kpi/registers', {
                        params: {
                            startDate: this.startDate,
                            endDate: this.endDate,
                        },
                    });

                    const { data: creditsSold } = await axios.get('/admin/kpi/credits-sold', {
                        params: {
                            startDate: this.startDate,
                            endDate: this.endDate,
                        },
                    });

                    const { data: recurrentsPaid } = await axios.get('/admin/kpi/recurrents-paid', {
                        params: {
                            startDate: this.startDate,
                            endDate: this.endDate,
                        },
                    });

                    const { data: bidsSplit } = await axios.get('/admin/kpi/bids-split', {
                        params: {
                            startDate: this.startDate,
                            endDate: this.endDate,
                        },
                    });

                    this.bidSplitTotalIncome = bidsSplit.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.bid_transaction.amount_fee), 0);
                    this.bidSplitTotal = bidsSplit.reduce((accumulator, currentValue) => accumulator += 1, 0);

                    this.creditsTotalIncome = creditsSold.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.income), 0);
                    this.recurrentTotalIncome = recurrentsPaid.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.income), 0);

                    this.creditsTotal = creditsSold.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);
                    this.recurrentTotal = recurrentsPaid.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);

                    this.registerTotal = registers.reduce((accumulator, currentValue) => accumulator + currentValue.total, 0);

                    const labels = [];
                    const startDate = this.startDate ? moment(this.startDate).startOf('month') : moment().subtract(6, 'month').startOf('month');
                    const endDate = this.endDate ? moment(this.endDate).startOf('month') : moment().startOf('month');

                    while (startDate.isSameOrBefore(endDate, 'month')) {
                        labels.push(startDate.format('MMMM YYYY'));
                        startDate.add(1, 'month');
                    }

                    this.renderChart({
                        labels: labels,
                        datasets: [
                            {
                                label: 'Intermediação de demandas',
                                backgroundColor: '#FFF5EE95c',
                                data: bidsSplit.map(row => row.bid_transaction.amount_fee),
                                type: 'line',
                            },
                            {
                                label: 'Vendas de Crédito',
                                backgroundColor: '#f879795c',
                                data: creditsSold.map(row => row.income),
                                type: 'line',
                            },
                            {
                                label: 'Planos Recorrentes',
                                backgroundColor: '#79f8bf75',
                                data: recurrentsPaid.map(row => row.income),
                                type: 'line',
                            },
                            {
                                label: 'Cadastros',
                                backgroundColor: '#00b5ff',
                                data: registers.map(row => row.total),
                            },
                        ],
                    }, { responsive: true, maintainAspectRatio: false });

                }catch (error) {

                    console.error('Erro ao obter os dados ou renderizar UserConvertionChart:', error);

                }

            },
            filterChart() {
                this.updateChart();
            },
        },
    };

</script>
